<template>
  <div class="wrapper">
    <h2>Online Multiple QRCode</h2>
  </div>
</template>

<script>
  export default {
    data() {
      return {}
    }
  }
</script>

<style scoped>
</style>
